import "./SuspenseLoading.css";
import Polygon1SVG from "../../../Images/Board/Polygon1SVG";
import Polygon2SVG from "../../../Images/Board/Polygon2SVG";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import TextShimmer from "../Loading/TextShimmer";
import loadingMessages from "../../../constants/loadingMessages";

const SuspenseLoading = () => {
  const { t } = useTranslation();

  const randomMessage = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * loadingMessages.length);
    return loadingMessages[randomIndex];
  }, []);

  return (
    <section className="SuspenseLoadingWrapper">
      <Polygon1SVG
        fill="var(--purple)"
        className="absolute left-0 top-0 cursor-default"
      />
      <Polygon2SVG
        fill="var(--purple)"
        className="absolute left-0 top-0 cursor-default max-xl:!h-[110vh]"
      />
      <TextShimmer
        as="h2"
        className="text-[32px] max-lg:text-[26px] max-sm:text-[22px] font-semibold text-center mr-4 relative z-50"
      >
        {t(randomMessage)}
      </TextShimmer>
      <h4 className="flex items-center gap-4 text-[24px] max-lg:text-[20px] max-sm:text-[16px] text-bgBlack font-normal text-center mr-4 relative z-50">
        <div className="loader"></div>
        <span>{t("Loading...")}</span>
      </h4>
    </section>
  );
};

export default SuspenseLoading;
